import { render, staticRenderFns } from "./TreatmentsPerWeek.vue?vue&type=template&id=395072b0&"
import script from "./TreatmentsPerWeek.vue?vue&type=script&lang=js&"
export * from "./TreatmentsPerWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports